import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "carousel",
  "aria-roledescription": "carousel",
  "aria-label": "Mission Squad connectors"
}
const _hoisted_2 = { class: "carousel-head" }
const _hoisted_3 = { class: "carousel-count text-disabled" }
const _hoisted_4 = { class: "carousel-nav" }
const _hoisted_5 = {
  ref: "track",
  class: "carousel-track"
}
const _hoisted_6 = {
  key: 0,
  class: "cx-logo--byo bg-primary"
}
const _hoisted_7 = { class: "cx-name" }
const _hoisted_8 = { class: "cx-desc text-medium-emphasis" }
const _hoisted_9 = { class: "cx-tag text-disabled" }
const _hoisted_10 = { class: "carousel-dots" }
const _hoisted_11 = ["aria-label", "onClick"]
const _hoisted_12 = { class: "shot-cap text-disabled" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_LogoTile = _resolveComponent("LogoTile")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.connectorCount) + " connectors", 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_btn, {
            class: "carousel-btn",
            variant: "text",
            ripple: false,
            disabled: _ctx.atStart,
            "aria-label": "Previous connectors",
            onClick: _ctx.prevPage
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: "mdi-chevron-left",
                size: "22"
              })
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_v_btn, {
            class: "carousel-btn",
            variant: "text",
            ripple: false,
            disabled: _ctx.atEnd,
            "aria-label": "Next connectors",
            onClick: _ctx.nextPage
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: "mdi-chevron-right",
                size: "22"
              })
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      _createElementVNode("div", {
        ref: "viewport",
        class: "carousel-viewport",
        tabindex: "0",
        role: "group",
        "aria-label": "Connectors — use arrow keys to browse",
        onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args))),
        onKeydown: [
          _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]), ["right"])),
          _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]), ["left"]))
        ]
      }, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connectors, (c) => {
            return (_openBlock(), _createBlock(_component_v_card, {
              key: c.name,
              class: _normalizeClass(["cx-card", { 'cx-card--byo': c.byo }]),
              color: "surface",
              rounded: "lg",
              variant: c.byo ? 'outlined' : 'elevated',
              elevation: c.byo ? undefined : 1
            }, {
              default: _withCtx(() => [
                (c.byo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-plus",
                        size: "22"
                      })
                    ]))
                  : (_openBlock(), _createBlock(_component_LogoTile, {
                      key: 1,
                      logo: c.logo,
                      alt: c.name + ' logo',
                      size: 44,
                      class: "mb-1"
                    }, null, 8, ["logo", "alt"])),
                _createElementVNode("div", _hoisted_7, _toDisplayString(c.name), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(c.desc), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(c.tag), 1)
              ]),
              _: 2
            }, 1032, ["class", "variant", "elevation"]))
          }), 128))
        ], 512)
      ], 544),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (i) => {
          return (_openBlock(), _createElementBlock("button", {
            key: i,
            type: "button",
            class: _normalizeClass({ active: i - 1 === _ctx.page }),
            "aria-label": 'Go to page ' + i,
            onClick: ($event: any) => (_ctx.goToPage(i - 1))
          }, null, 10, _hoisted_11))
        }), 128))
      ])
    ]),
    _createElementVNode("p", _hoisted_12, [
      _createVNode(_component_v_icon, {
        icon: "mdi-shield-check-outline",
        size: "15",
        class: "shot-cap__icon"
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.caption), 1)
    ])
  ]))
}